<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
          <vs-popup classContent="popup-example flex flex-wrap justify-center" title="แจ้งเตือน" :active.sync="popupActive">
            <vs-row class="py-2">{{ popupText }}</vs-row>
          </vs-popup>

          <vx-card>
            <div slot="no-body" class="full-page-bg-color">
              <div class="vx-row">
                  <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                      <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                  </div>
                  <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                      <div class="p-8">
                        <div class="vx-card__title mb-8">
                            <h4 class="mb-4">รีเซ็ตรหัสผ่าน</h4>
                            <p>กรุณากรอกรหัสผ่านใหม่ของคุณ.</p>
                        </div>

                        <vs-input
                          data-vv-validate-on="blur"
                          v-validate="'required|min:6|max:10'"
                          data-vv-name="validate_password"
                          type="password"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          label-placeholder="รหัสผ่าน"
                          v-model="password"
                          class="w-full mt-6" />
                        <span class="text-danger text-sm">{{ errors.first('validate_password') }}</span>
                        <vs-input
                          data-vv-validate-on="blur"
                          v-validate="'required|min:6|max:10'"
                          data-vv-name="validate_confirm_password"
                          type="password"
                          name="confirm_password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          label-placeholder="ยืนยันรหัสผ่าน"
                          v-model="confirm_password"
                          class="w-full mt-6" />
                        <span class="text-danger text-sm">{{ errors.first('validate_confirm_password') }}</span>

                        <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row my-5">
                            <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">กลับสู่หน้าเข้าสู่ระบบ</vs-button>
                            <vs-button class="w-full sm:w-auto" :disabled="!isFormValid" @click="resetPassword">รีเซ็ต</vs-button>
                        </div>

                      </div>
                  </div>
              </div>
            </div>
          </vx-card>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      password: '',
      confirm_password: '',
      token: '',
      popupActive: false,
      popupText: ''
    }
  },
  methods : {
    resetPassword () {
      const vm = this
      this.$store.dispatch('admin_api/resetPassword', { password: this.password, confirm_password: this.confirm_password, token: this.token
      }).then((res) => {
        if (res) {
          vm.popupText = 'รีเซ็ตรหัสผ่านสำเร็จ'
          vm.popupActive = true
        }
      }).catch(err => {
        if (err.data.Message === 'New password and Confirm password not match') {
          vm.popupText = 'รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน'
          vm.popupActive = true
        }
      })
    }
  },
  computed: {
    isFormValid () {
      return !this.errors.any() && this.password && this.confirm_password
    }
  },
  created () {
    const vm = this
    if (this.$route.query.token) {
      vm.token = vm.$route.query.token
    }
  }
}
</script>
